var utils  = require( './utils' ),
	header = require( './sticky-header' );

var sticky_title_bar = ( function( $ ) {

	var stick_title_bar = function( $title_bar, offset ) {
		$title_bar.addClass( 'sticky' );

		offset_content( true, offset );
	};

	var unstick_title_bar = function( $title_bar ) {
		$title_bar.removeClass( 'sticky' );
		offset_content( false );

		$title_bar.find( '.left, .right' ).css( 'height', 'auto' );
	};

	var offset_content = function( offset, height ) {
		var $content = $( '#content' );

		if ( offset ) {
			height = typeof height !== 'undefined' ? height : header.collapsed_height;

			if ( $content.css( 'padding-top' ) === height ) {
				return;
			}

			$content.css( 'padding-top', height + 'px' );
		} else {
			$content.css( 'padding-top', '0' );
		}
	};

	return {
		stick_title_bar : stick_title_bar,
		unstick_title_bar : unstick_title_bar,
		offset_content : offset_content
	}

} ) ( jQuery );

module.exports = sticky_title_bar;